import {
  Form,
  TextInput,
  SelectInput,
  PasswordInput,
  required,
  SaveButton
} from 'react-admin'
import { useCallback } from 'react'
import { Box, Grid, Typography, Link } from '@mui/material'
import CheckboxInput from '@/components/CheckboxInput'
import SignUpFormValues from '../types/SignUpFormValues'
import {
  GoogleReCaptcha,
  GoogleReCaptchaProvider
} from 'react-google-recaptcha-v3'
import Storage from '@/lib/Storage'
import CONSTANTS from '@/constants'

type Props = {
  onSubmit?: (values: SignUpFormValues) => void
  onTermsClick: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
}

const SignUpForm = ({ onSubmit, onTermsClick }: Props) => {
  const { setRecaptchaToken } = Storage()

  const handleSubmit = (values: unknown) => {
    if (values) onSubmit?.(values as SignUpFormValues)
  }

  const onCaptchaVerify = useCallback(
    (token: string) => setRecaptchaToken(token),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return (
    <GoogleReCaptchaProvider reCaptchaKey={CONSTANTS.RECAPTCHA_V3_SITE_KEY}>
      <GoogleReCaptcha onVerify={onCaptchaVerify} refreshReCaptcha />
      <Form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 6 }}>
            <TextInput source="first_name" validate={required()} />
          </Grid>
          <Grid size={{ xs: 6 }}>
            <TextInput source="last_name" validate={required()} />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid size={{ xs: 6 }}>
            <TextInput source="email" validate={required()} type="email" />
          </Grid>
          <Grid size={{ xs: 6 }}>
            <TextInput source="company" validate={required()} />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid size={{ xs: 6 }}>
            <PasswordInput
              source="password"
              placeholder="Must be at least 6 characters"
              validate={required()}
            />
          </Grid>
          <Grid size={{ xs: 6 }}>
            <PasswordInput
              source="password_confirmation"
              placeholder="Must match the password"
              validate={required()}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid size={{ xs: 6 }}>
            <TextInput source="website" validate={required()} />
          </Grid>
          <Grid size={{ xs: 6 }}>
            <SelectInput
              source="audience_size"
              defaultValue="0+"
              validate={required()}
              choices={[
                { id: '0+', name: 'Less than 250k' },
                { id: '250000+', name: '250k - 500k' },
                { id: '500000+', name: '500k - 1M' },
                { id: '1000000+', name: '1M+' }
              ]}
            />
          </Grid>
        </Grid>
        <CheckboxInput
          source="terms_of_service"
          validate={required()}
          sx={{ width: '100%', justifyContent: 'center' }}
        >
          <Typography component="span">
            Agree to our{' '}
            <Link href="#" onClick={onTermsClick}>
              Terms and Conditions
            </Link>
          </Typography>
        </CheckboxInput>
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <SaveButton
            variant="outlined"
            icon={<></>}
            label="Sign Up"
            size="large"
            sx={{ width: '50%' }}
          />
        </Box>
      </Form>
    </GoogleReCaptchaProvider>
  )
}

export default SignUpForm
